import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationUpdateUserReferrerSourceArgs, BackendUser } from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateUserReferrerSource($referrerSource: String, $referrerOtherSource: String) {
    updateUserReferrerSource(
      referrerSource: $referrerSource
      referrerOtherSource: $referrerOtherSource
    ) {
      id
    }
  }
`;

type Variables = BackendMutationUpdateUserReferrerSourceArgs;
type Result = Pick<BackendUser, 'id'>;

export const updateUserReferrerSource = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
